module.exports = __webpack_public_path__ + "img/service1@2x.0535e534.png";